<template>
  <div class="cardWrap clearfix">
    <div class="cardText clearfix" @click.stop="titleHandle">
      <!-- checkBox -->
      <div style="float: left">
        <slot />
      </div>
      <div class="logoAndStar clearfix" style="margin-right:16px">
        <div v-if="baseData.logoPath" class="logo"><img :src="repliceHttps(baseData.logoPath)" alt="" srcset="" @error.once="baseData.logoPath = null"></div>
        <div v-else :class="['logo2',{'aliasLineHeight': aliasLineHeight}]" :style="'background:'+ backgroundColor">{{setLineHeight(baseData.alias)}}</div>
      </div>
      <div class="details">
        <div class="nameWrap mb-10" style="display: flex;margin-bottom:8px">
          <span class="name textOverflow" style="font-size:15px;font-weight: bold;    line-height: 20px;" v-html="companyNameColor || '--'"></span>

     
          <el-tag size="mini" style="color:#30BF78" type='success' v-if="baseData.regStatus">{{baseData.regStatus}}</el-tag>

          <div v-if="baseData.unlockType===2" class="playGet font-12">赠</div>
          <div class="star ml-10">
            <div :class="['bg',{'unstar':!baseData.star}]" @click.stop="handleStarB"></div>
          </div>
        </div>
        <!-- <div class="tags mb-20" v-if="baseData.tags">
          <span>
            <el-tag class="mr-10" size="mini" v-for="(tag,i) in baseData.tags.split(',')" :key="i">{{tag}}</el-tag>
          </span>
        </div> -->
        <!-- v-if="baseData.isATaxpayer == '1' || baseData.isUnicorn == '1' || baseData.hasGazelles == '1'|| baseData.listedEnterPrises == '1'|| baseData.isHiTech == '1'|| baseData.hasTop500 == '1'" -->

        <div style="display: flex;flex-wrap: wrap; display:none" v-if="baseData.tags">
          <p class="tag-title" v-for="(tag,i) in baseData.tags.split(',')" :key="i">{{tag}}</p>
        </div>

        <dl class="text">
          <!-- <dd class="mr-10">
            <div class="textOverflow">
              <span>企业法人：</span> <span v-html="baseData.legalPersonName || '--'"></span>
            </div>
            <div class="textOverflow">
              <span>企业规模：</span><span>{{staffSize}}</span>
            </div>
          </dd>
          <dd class="mr-10">
            <div class="textOverflow">
              <span>注册资本：</span>
              <span v-if="baseData.regCapital">{{baseData.regCapital}}</span>
              <span v-else>{{regCapital}}</span>
            </div>
            <div class="textOverflow">
              <span>企业网址：</span>
              <a v-if="companyWeb" :href="goUrl(companyWeb)" target="_blank" style="color:#4f7afd;font-size:12px;">{{companyWeb}}</a>
              <span v-else>--</span>
            </div>
          </dd> -->
          <dd class="mr-10">
            <div class="textOverflow">
              <span>成立日期：</span>
              <span v-if="baseData.establishTime">{{baseData.establishTime | formatTime }}</span>
              <span v-else>{{baseData.estiblishTime | formatTime }}</span>
            </div>
            <div class="textOverflow">
              <span>所属行业：</span>
              <span  :title="companyIndustry">{{companyIndustry}}</span>
            </div>
          </dd>
        </dl>
        <div class="address textOverflow2">
          <span>注册地址：</span><span v-html="this.address || '--'"></span>
        </div>
      </div>
    </div>

    <!-- 优先显示产品 -->
    <!-- <div class="tm textOverflow" v-if="baseData.brands" :title="removeHtml(unique(baseData.brands))">
      <img src="@/assets/tm.svg" alt="" srcset="">产品：<span v-html="unique(baseData.brands)"></span>
    </div>

    <div class="tm textOverflow" v-if="!baseData.brands && baseData.tmName" :title="removeHtml(unique(baseData.tmName))">
      <img src="@/assets/tm.svg" alt="" srcset="">商标：<span v-html="unique(baseData.tmName)"></span>
    </div>
    <div class="firstTime">
      <span v-if="baseData.lastDate">最近访问时间:{{baseData.lastDate}}</span>
      <span v-if="baseData.firstDate">首访时间:{{baseData.firstDate}}</span>
      <span v-if="baseData.refererType>=0">访问来源:{{getrefererType(baseData.refererType)}}</span>
      <span v-if="baseData.count">累计频次:{{baseData.count}}次</span>
      <span v-if="baseData.mainUrl" :title="baseData.mainUrl" class="mainUrl">站点:{{baseData.mainUrl}}</span>
    </div> -->
    <!-- 查看号码抽屉 -->
    <!-- <view-number :companyType="companyTypeNum" ref="vNumber" :baseData="numberData" :companyStatus="companyStatus" :waiting="waiting" @refreshList="contactList" @lookNumber="lookNumberInner" /> -->
    <ViewNumber ref="vNumber" v-if="drawerShow!==null" :show.sync="drawerShow" :companyStatus="companyStatus" />

  </div>
</template>
<script>
import { parseTime, debounce } from '@/base/global'
import ViewNumber from '@/components/viewNumber'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { star } from '../api/index'
import { uninterested, contactList, contactCount } from '../api/newClueApi'
import lockNumber from './../mixins/lockNumber.js'

export default {
  name: 'companyCard1',
  mixins: [lockNumber],
  components: {
    ViewNumber
  },
  props: {
    // 智能推荐栏
    showRecommend: {
      type: Boolean,
      default: true
    },
    // 小T
    xiaoT: {
      type: Boolean,
      default: false
    },
    // 基本数据
    baseData: {
      type: Object,
      default () {
        return {
          base: '上海', // 地区推荐
          name: '小米1',
          legalPersonName: '王川王川', // legalPersonName
          regCapital: '13000万美元', // regCapital
          createTime: '2010-08-25', // createTime
          regStatus: '在业',
          // city: '上海上海上海上海',//
          regLocation: '北京市海淀区西二旗中路33号院6号楼9层019号', // ，
          star: false,
          unlock: false,
          contactCount: {}
        }
      }
    },
    companyType: {
      type: Number
    }
  },
  data () {
    return {
      drawerShow: null,
      feedBack: ['行业不符合', '地区不符合', '号码质量差', '其他原因'],
      checkList: [],
      visible: false,
      aliasLineHeight: false,
      // bgColor: ['#8ca3cd', "#c8b7d8", '#90cfb7', '#ae98c6', '#8ca3cc', '#e79178', '#adddf3', '#f56c6c', '#5daf34'],
      bgColor: ['#7DB3D9', '#84CAB0', '#8CA3CD', '#BC9EDD'],
      waiting: false,
      numberData: [],
      drawer: false,
      companyStatus: {
        companyName: '',
        name: '',
        lockStatus: false,
        contactCount: {}
      },
      companyTypeNum: this.companyType
    }
  },
  watch: {
    // 联系方式次数查询之后设置
    'baseData.contactCount': {
      immediate: true,
      handler (val) {
        if (val) {
          this.companyStatus.contactCount = val
        }
      }
    }
  },
  filters: {
    formatTime (val) {
      if (val) {
        if (typeof val === 'string') val = val.replace(/-/ig, '/')
        return parseTime(new Date(val), '{y}-{m}-{d}')
      }
      return '--'
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus
    }),
    regCapital () {
      if (this.baseData.amount === -1) {
        return '--'
      }
      if (this.baseData.registeredCapital && this.baseData.registeredCapital !== '0.0' && this.baseData.unit && this.baseData.currency) {
        return this.baseData.registeredCapital + this.baseData.unit + this.baseData.currency
      }
      return '--'
    },
    staffSize () {
      const staffSize = this.baseData.staffSize
      if (staffSize) {
        // if (staffSize.endsWith('人')) return staffSize
        if (staffSize.includes('人')) return staffSize
        return staffSize + '人'
      }
      return '--'
    },
    companyWeb () {
      if (!this.baseData.websiteList) {
        return false
      }
      if (this.baseData.websiteList.includes(',')) {
        return this.baseData.websiteList.split(',')[0]
      }
      return this.baseData.websiteList
    },
    companyNameColor () {
      return this.baseData.name || this.baseData.companyName
    },
    companyName () {
      return this.removeHtml(this.baseData.name || this.baseData.companyName || this.baseData.unlabeledCompanyName)
    },
    companyAddress () {
      return this.removeHtml(this.baseData.regAddress || this.baseData.regLocation)
    },
    legalPersonName () {
      return this.removeHtml(this.baseData.legalPersonName)
    },
    textTitle () {
      if (this.baseData.similarity) {
        return `${this.baseData.similarValue}，相似度：${(this.baseData.similarity * 10000 / 100).toFixed(2)}% `
      }
      return this.baseData.similarValue
    },
    backgroundColor () {
      return this.bgColor[this.baseData.color]
    },
    address () {
      return this.baseData.regAddress || this.baseData.regLocation
    },
    companyIndustry() {
      if (this.baseData.bigIndustry) {
        const { bigIndustry, smallIndustry, thirdName, fourName } = this.baseData
        if (bigIndustry && smallIndustry && thirdName && fourName) {
          return `${bigIndustry}>${smallIndustry}>${thirdName}>${fourName}`
        }
        else if (bigIndustry && smallIndustry && thirdName) {
          return `${bigIndustry}>${smallIndustry}>${thirdName}`
        }
        else if (bigIndustry && smallIndustry) {
          return `${bigIndustry}>${smallIndustry}`
        }
        else if (bigIndustry) {
          return bigIndustry
        }
        return '--'
      }

      const { industry, subIndustry, thirdName, fourName } = this.baseData
      if (industry && subIndustry && thirdName && fourName) {
        return `${industry}>${subIndustry}>${thirdName}>${fourName}`
      }
      else if (industry && subIndustry && thirdName) {
        return `${industry}>${subIndustry}>${thirdName}`
      }
      else if (industry && subIndustry) {
        return `${industry}>${subIndustry}`
      }
      else if (industry) {
        return industry
      }
      return '--'
    },
  },
  methods: {
    getrefererType (item) {
      return ['直接访问', '直接入站', '搜索引擎入站', '网站入站'][item]
    },

    goUrl (url) {
      var newurl = ''
      if (url.indexOf('http:') == -1 && url.indexOf('https:') == -1) {
        newurl = 'http://' + url
        return newurl
      } else {
        return url
      }
    },
    handleStarB: debounce('handleStar', 300),
    repliceHttps (str) {
      if (!str) return
      const urlP = /^http:\/\/.+/
      if (str.match(urlP)) {
        return str.replace('http://', 'https://')
      }
      return str
    },
    // 去重
    unique (str) {
      return this.simpleUnique(str.split(',')).join()
    },
    // 简单数组去重
    simpleUnique (array) {
      var result = []
      var hash = {}
      for (var i = 0; i < array.length; i++) {
        var key = (typeof array[i]) + array[i]
        if (!hash[key]) {
          result.push(array[i])
          hash[key] = true
        }
      }
      return result
    },
    titleHandle () {
       // 当HID为空时
      if(this.baseData.hid == null || this.baseData.hid == ''){
            this.$message({
                message: '该企业未收录',
                type: 'warning'
              });
        return false
      }
      Object.assign(this.companyStatus, this.baseData)
      this.companyStatus.companyName = this.companyName
      this.companyStatus.lockStatus = this.baseData.unlock
      this.companyStatus.regAddress = this.companyAddress
      this.companyStatus.legalPersonName = this.legalPersonName
      
      if (window.__sendIframeMessage(this.companyStatus)) return
      
      if (this.surplus < 1 && !this.baseData.unlock) {
        this.$store.dispatch('PERMISSION_CONFIRM')
        return
      }
      this.showDrawer()
    },
    // changeNews() {
    //   this.$emit('changeNews-handle', this.companyName)
    // },
    changeRecommendList () {
      this.$emit('change-recommendList')
    },
    setLineHeight (val) {
      if (val && val.length > 0) {
        const zm = /^[A-Za-z]+$/g
        if (zm.test(val) && val.length < 4) {
          this.aliasLineHeight = true
        } else if (val.length < 3) {
          this.aliasLineHeight = true
        }
      }
      const zz = /[\u4e00-\u9fa5]/g
      if (val) return val.substr(0, 4)
      
      return this.companyName.match(zz).join('').substr(0, 4)
    },
    showDrawer () {
      this.baseData.unlock = true
      this.companyStatus = { ...this.baseData, legalPersonName: this.legalPersonName, regAddress: this.companyAddress, companyName: this.companyName, lockStatus: true }
      this.drawerShow = true
    },
    removeHtml (str) {
      if (!str) return
      str = str.replace('<<', '@@@').replace('>>>', '>@1@1@1')
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '').replace('@@@', '<<').replace('@1@1@1', '>>')
    },
    lookNumberInner () {
      // 不刷新显示解锁
      this.baseData.unlock = true
      this.$emit('unlock-change')
      this.companyStatus = { ...this.baseData, legalPersonName: this.legalPersonName, regAddress: this.companyAddress, companyName: this.companyName, lockStatus: true }
      this.contactCount()
    },
    async handleStar () {
      let type // 1标准资源 2智能推荐
      this.baseData.similarValue ? type = 2 : type = 1
      let collect // 1收藏 0 取消
      this.baseData.star ? collect = 0 : collect = 1
      const res = await star({ collect, type, name: this.companyName,hid:this.baseData.hid, similarValue: this.baseData.similarValue, similarity: this.baseData.similarity })
      if (res.code === 200) {
        if (collect) {
          this.$message.success('收藏成功！')
        } else {
          this.$message.success('取消收藏成功！')
        }
        this.baseData.star = !this.baseData.star
      } else {
        this.$message.success(res.message)
      }

      if (collect) this.changeRecommendList()
    },
    async uninterested (companyName, reason) {
      await uninterested({ companyName, reason })
      this.$message.success('操作成功')
      this.changeRecommendList()
    }
  }
}
</script>

<style lang="scss" scoped>
.firstTime {
  margin-left: 70px;
  margin-top: 15px;
  color: #409eff;
  > span {
    margin-right: 15px;
    font-size: 12px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mainUrl {
    width: 350px;
  }
}

.cardWrap {
  height: 205px !important;
  padding: 10px 20px;
  border: 1px solid #f0f2f5;
  margin-top: 20px;
  // margin-right: 25px;
  float: left;
  cursor: pointer;
  transition: all 0.3s, height 0s;
  &:hover {
    position: relative;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .recommend {
    float: initial;
    margin: 10px 0;
    .tRecommend {
      display: flex;
      float: left;
      // margin-left: 100px;
      height: 24px;
      line-height: 24px;
      border: 1px solid #ecd4c1;
      color: #b68060;
      background-image: url("~@/assets/icon/xtb.png");
      background-size: contain;
      background-repeat: no-repeat;
      // padding-left: 92px;
      padding-right: 12px;
      border-radius: 5px;
      // max-width: 68%;
      .left {
        width: 92px;
        font-size: 0;
        > span {
          font-size: 12px;
          vertical-align: top;
          color: #333;
        }
        > img {
          height: 100%;
          margin-left: 3px;
        }
      }
      .text2 {
        display: flex;
        align-items: flex-end;
        height: 22px;
        line-height: 22px;
        font-size: 12px;
        > span {
          display: inline-block;
          font-size: 12px;
          max-width: 328px;

          &:last-child {
            // width: calc(100% - 115px);
            vertical-align: top;
          }
        }
        span i {
          font-size: 14px;
        }
      }
    }
    .rightBtn {
      float: right;
      text-align: right;
      line-height: 24px;
      span {
        display: inline-block;
        color: #f59a23;
        text-decoration-line: underline;
        cursor: pointer;
        margin: 0 10px;
      }
      span:hover {
        color: #dc8b22;
      }
    }
  }
  .recommend-noMargin {
    margin: 0;
  }
  .tm {
    display: inline-block;
    margin-top: 10px;
    margin-left: 70px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    text-align: left;
    color: #666;
    background-color: #fafafa;
    padding: 0 10px;
    border-radius: 5px;
    max-width: calc(100% - 160px - 70px);
    > img {
      margin-right: 5px;
      position: relative;
      top: -1px;
      width: 12px;
    }
    > span {
      font-size: 12px;
    }
  }

  .logoAndStar {
    width: 58px;
    float: left;
    margin-right: 10px;
    .logo {
      float: right;
      width: 60px;
      height: 60px;
      font-size: 0;
      overflow: hidden;
      > img {
        width: 100%;
      }
    }
    .logo2 {
      float: left;
      font-weight: bold;
      width: 58px;
      height: 58px;
      padding: 6px;
      background-color: royalblue;
      font-weight: 400;
      color: #fff;
      text-align: center;
    font-size: 16px;
    line-height: 23px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .aliasLineHeight {
      line-height: 48px;
    }
  }
  .details {
    width: calc(100% - 87px);
    float: left;
    // height: 222px;
    // .logo {
    //   float: left;
    //   width: 60px;
    //   height: 60px;
    //   padding: 6px;
    //   background-color: royalblue;
    //   font-weight: 400;
    //   color: #fff;
    //   text-align: center;
    //   font-size: 21px;
    //   line-height: 24px;
    //   border-radius: 4px;
    //   margin-right: 10px;
    // }
    .aliasLineHeight {
      line-height: 48px;
    }
    .nameWrap {
      .name {
        display: inline-block;
        position: relative;
        // top: 5px;
        max-width: 40%;
        font-size: 20px;
        font-weight: 500;
        color: #000;
      }
      /deep/ .el-tag {
        position: relative;
        top: -1px;
        margin-left: 10px;
      }
      .star {
        // float: left;
        display: inline-block;
        width: 20px;
        // height: 20px;
        position: relative;
        margin-top: -1px;
        > div {
          cursor: pointer;
        }
        .bg {
          // background-image: url("~@/assets/industry/star2.png");
          background-image: url("~@/assets/gbIcon/xx.svg");
          background-repeat: no-repeat;
          width: 20px;
          height: 20px;
          background-size: 100%;
          position: relative;
          // top: 5px;
        }
        .unstar {
          background-image: url("~@/assets/gbIcon/star.png");
          // background-image: url("~@/assets/industry/star.png");
        }
      }
      .playGet {
        display: inline-block;
        margin-left: 10px;
        background-color: #ebb563;
        color: #fff;
        border-radius: 9px;
        padding: 2px 10px;
      }
    }

    .tags {
      span {
        margin-right: 10px;
      }
      .loadingBtn {
        padding: 0px 5px;
        margin-right: 10px;
        line-height: 18px;
        font-size: 12px;
        background-color: #fdf6ec;
        border-color: #faecd8;
        color: #e6a23c;
      }
    }
    span {
          font-size: 12px;
        font-weight: 400;
        color: rgba(102, 102, 102, 0.6);
    }
    
    .text {
      text-align: left;
      dd {
        font-size: 12px;
        display: inline-block;
        > div {
          margin-bottom: 8px;
        }
        span:nth-child(2) {
          color: #666666;
        }
        &:nth-child(1) {
          min-width: 140px;
          max-width: 90%;
        }
        &:nth-child(2) {
          width: 210px;
        }
        &:nth-child(3) {
          max-width: 355px;
        }
      }
      dt {
        display: inline-block;
        margin: 0 20px;
      }
      span {
        font-size: 12px;
        font-weight: 400;
        color: rgba(102, 102, 102, 0.6);
      }
    }
    .address {
      // text-overflow: ellipsis;
      // overflow: hidden;
      // white-space: nowrap;
      color: #999;
      span:nth-child(2) {
        color: #666666;
      }
    }

    .tag-title {
      // width: 80px;
      // height: 20px;
      padding: 0px 16px;
      margin-bottom: 8px;
      line-height: 24px;
      margin-right: 8px;
      text-align: center;
      font-size: 12px;
      border-radius: 3px;
      background: rgba(80, 136, 255, 0.15);
      color: #5088FF;
    }
  }
  .cardText {
    position: relative;
    width: 100%;
    height: 100%;
    .btns {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      .btn-tip {
        line-height: 30px;
        color: #666;
        text-align: center;
        font-size: 12px;
        span {
          padding: 0 2px;
          color: #409eff;
        }
      }
    }
  }
}
</style>
